<template>
  <v-row class="ma-0 pa-0 px-4 py-2">
    <v-col class="ma-0 pa-0" cols="12">
      <v-simple-table
        dense
        style="
          border-style: solid;
          border-width: 1px;
          border-color: rgba(0, 0, 0, 0.15);
        "
      >
        <template v-slot:default>
          <thead>
            <tr>
              <th
                class="text-left"
                v-for="header in table.headers"
                :key="`simple-table-headers-${header}`"
              >
                {{ header }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(line, lineIndex) in table.lines"
              :key="`simple-table-line-${lineIndex}`"
            >
              <td
                v-for="header in table.headers"
                :key="`simple-table-column-${line[header]}`"
              >
                {{ line[header] }}
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
    <v-col class="ma-0 pa-0 pl-1 mt-1" cols="12">
      <p class="ma-0 pa-0 simple-table-caption">{{ table.caption }}</p>
    </v-col>
  </v-row>
</template>

<style>
.simple-table-caption {
  font-size: 10px;
}
</style>

<script>
export default {
  data() {
    return {};
  },
  props: {
    table: {
      type: Object,
      default: null,
      required: true,
    },
  },
};
</script>